import React from 'react';
import {AgGridColumn} from "../../../components/agGridColumn";
import Grid, {ListaMultiplaFilter} from '../../../components/grid';
import { ActionProps } from '../../../components/gridAction';
import enumDescription from "../../../services/enumDescription";
import {StackExecuteTaskList, StatusExecuteTaskList, TypeExecuteTaskList} from "./index";

const ExecuteTaskList = (props:any) => {

    class FiltroType extends ListaMultiplaFilter{
        getList(): enumDescription {
            return TypeExecuteTaskList;
        }
    }

    const typeListFormater  = (params:any) =>{
        return TypeExecuteTaskList.getDescription(params.value);
    }

    class FiltroStatus extends ListaMultiplaFilter{
        getList(): enumDescription {
            return StatusExecuteTaskList;
        }
    }

    const statusListFormater  = (params:any) =>{
        return StatusExecuteTaskList.getDescription(params.value);
    }

    class FiltroStack extends ListaMultiplaFilter{
        getList(): enumDescription {
            return StackExecuteTaskList;
        }
    }

    const stackFormater = (params:any) => StackExecuteTaskList.getDescription(params.value) || 'Agente de IA';

    const execucaoFormater = (params:any) => params.value === true
        ? 'Até ' + (params.data?.limiteSimultaneo ?? 5) + ' ao mesmo tempo'
        : 'Um por vez';

    const casosFormater = (params:any) => params.value === undefined || params.value === null
        ? ''
        : params.value + ' × ' + (params.data?.qtdMockups ?? 0);

    const actions: Array<ActionProps> = [
        {
            route:'execute-task/incluir',
            color:'success',
            type:'normal',
            title:'Incluir'
        },
        {
            route:'execute-task/alterar',
            color:'warning',
            type:'grid',
            title:'Alterar'
        },
        {
            route:'execute-task/delete',
            color:'danger',
            type:'delete',
            title:'Excluir'
        },
        {
            route:'execute-task/execute',
            color:'primary',
            type:'grid',
            title:'Executar e ver resultados'
        }
    ];

    return (
        <Grid actions={actions} rota="execute-task/list">
            <AgGridColumn sort="desc" width={100} headerName="#" checkboxSelection field="id"  sortable={ true } filter={'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn flex={1} minWidth={200} field="name" headerName={'Nome'}  sortable={ true } filter={ true }></AgGridColumn>
            <AgGridColumn width={200} headerName="Tipo"  field="type"  sortable={ true } filter={ FiltroType } valueFormatter={typeListFormater}></AgGridColumn>
            <AgGridColumn width={140} headerName="Stack"  field="stack"  sortable={ true } filter={ FiltroStack } valueFormatter={stackFormater}></AgGridColumn>
            <AgGridColumn width={180} headerName="Execução"  field="executarSimultaneo" valueFormatter={execucaoFormater}></AgGridColumn>
            <AgGridColumn width={150} headerName="Casos × Mockups"  field="qtdCasos" valueFormatter={casosFormater}></AgGridColumn>
            <AgGridColumn width={120} headerName="Issue"  field="issueId"  sortable={ true } filter={'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn width={170} headerName="Situação"  field="status"  sortable={ true } filter={ FiltroStatus } valueFormatter={statusListFormater}></AgGridColumn>
        </Grid>
    );
};
export default ExecuteTaskList;